import { defineStore } from 'pinia';
import services from '@/services';
import useApi from '@/hooks/useApi';
import useInfo from './info';
import utils from '@/utils/index';
import { Status } from '@/types/enums';
const { getParam } = utils;

interface IpState {
  record: {
    kvImage: string;
    text: string;
    audio: string;
  } | null;
  kv: {
    bgLandscape: string;
    bgPortrait: string;
  }[];
  cgVideos: {
    coverLandscape: string;
    coverPortrait: string;
    status: Status;
    unlockTime: number;
    youtubeId: string;
    title: string;
  }[];
  collections: {
    image: string;
    name: string;
  }[];
  chosenIpVideo: {
    coverLandscape: string;
    coverPortrait: string;
    status: Status;
    unlockTime: number;
    youtubeId: string;
    title: string;
  };
  chosenIpVideoIndex: number;
  isInitialized: boolean;
}

const ipState = (): IpState => ({
  record: null,
  kv: [],
  cgVideos: [],
  collections: [],
  chosenIpVideo: {
    coverLandscape: '',
    coverPortrait: '',
    status: 0,
    unlockTime: 0,
    youtubeId: '',
    title: '',
  },
  chosenIpVideoIndex: 0,
  isInitialized: false,
});

const useIp = defineStore('ip', {
  state: ipState,
  actions: {
    async getIp() {
      const { lang, region } = useInfo();
      if (!lang || !region) return;
      const accessToken =
        getParam('access_token') || localStorage.getItem('TOKEN');
      const response = await useApi(() =>
        services.getIp({ lang, region, ...(accessToken && { accessToken }) }),
      );
      if (!response || response.msg) return;
      const { data } = response;
      this.$patch({ ...data });
      this.setIsInitialized(true);
    },
    setIsInitialized(boolean: boolean) {
      this.isInitialized = boolean;
    },
    chooseIpVideo(data: IpState['chosenIpVideo']) {
      this.chosenIpVideo = data;
    },
    chooseIpVideoIndex(index: number) {
      this.chosenIpVideoIndex = index;
    },
  },
});

export default useIp;
